const ID = 'modal';

export default ID;
